import React, { useCallback, useEffect, useState, useContext, useMemo, useRef } from 'react';
import BarChart from '../components/charts/BarChart';
import Tabs from '../components/Tabs';
import Filter from '../components/Filter';
import { getAnimaisPerdaPreParto } from '../apis/apiAnimais';
import { Box, Grid, Tooltip } from '@mui/material';
import fieldsTables from '../utils/fieldsTables';
import showColumns from '../utils/showColumns';
import { showFilters } from '../utils/configFilters';
import Table from '../components/Table';
import Badge from '../components/Badge';
import dayjs from 'dayjs';
import { useSearchParams } from 'react-router-dom';
import EmptyState from '../components/EmptyState';
import Loading from '../components/Loading';
import { LanguageContext } from '../App';
import AccordionCustom from '../components/ArcodionCustom';
import PageForPrint from '../components/PageForPrint';
import Printer from '../components/Printer';
import { getPropriedades } from '../apis/apiPropriedades';
import Card from '../components/Card';
import GenericSummary from '../components/summaries/GenericSummary';
import SwitchCustom from '../components/SwitchCustom';
import InfoIcon from '@mui/icons-material/Info';

interface CardItem {
  title: string;
  value: string | number;
  big: boolean;
  tooltip?: string; 
}

interface StatusSummaryItem {
  name: string;
  absValue: number;
  percentValueByPerdas: number | string;
  percentValueByAll: number | string;
}

interface StatusList {
  animals: Reproduction[];
  name: string;
}

function IndicadoresPerdaPreParto() {
  const [loading, setLoading] = useState<boolean>(true)
  const [barChartDataByPerdas, setBarChartDataByPerdas] = useState<BarChartData[]>([])
  const [barChartDataByAll, setBarChartDataByAll] = useState<BarChartData[]>([])
  const [selectedTab, setSelectedTab] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState<string[]>([])
  const [allPerdasLength, setAllPerdasLength] = useState<number>(0);
  const [allStatus, setAllStatus] = useState<string[]>([])
  const [selectedAnimalsByStatus, setSelectedAnimalsByStatus] = useState<Reproduction[]>([])
  const [animals, setAnimals] = useState<Reproduction[]>([])
  const [searchParams] = useSearchParams();
  const { translations, setLanguage } = useContext(LanguageContext);
  const [datePlaceholder, setDatePlaceholder] = useState<string>("");
  const printRef1 = useRef(null);
  const printRef2 = useRef(null);
  const [farmName, setFarmName] = useState<string>("");
  const [filtersPrintRef, setFiltersPrintRef] = useState<FiltersPrintRefType | undefined>(undefined);
  const [, setIsPrinting] = useState<boolean>(false);
  const [cardList, setCardList] = useState<CardItem[]>([]);
  const [statusList, setStatusList] = useState<StatusSummaryItem[]>([]);
  const [barChartByReproduction, setBarChartByReproduction] = useState<boolean>(true)

  type FiltersPrintRefType = {
    espCodigo: string;
    racCodigo: string;
    catCodigo: string;
    lotCodigo: string;
  };
  
  type FarmsType = {
    proCodigo: number;
    proDescricao: string;
  }

  const statusParicaoEnum = useMemo(() => translations ? [
    translations["lbl.react.tabela.nao.parida"],
    translations["lbl.react.parida"],
    translations["lbl.react.tabela.abortado.lactacao"],
    translations["lbl.react.data.aborto"],
    translations["lbl.react.tabela.monta.sem.prenhez"],
    translations["lbl.react.natirmorto"],
    translations["lbl.react.perda.embrionaria"],
  ] : [], [translations]);

  const handleTableData = useCallback(() => {
    const animalsList = animals.filter((reproduction) => {
      return (selectedStatus.includes(statusParicaoEnum[reproduction.cobIndStatus!]))
      //return []
    })
   
    setSelectedAnimalsByStatus(animalsList)

  }, [animals, selectedStatus, statusParicaoEnum])

  const handleSelectBars = () => {
  }

  const handleDelete = (label: string) => {
    if (selectedStatus.includes(label)) {
      if (selectedStatus.length > 1) {
        const statusToShow = selectedStatus.filter(status => status !== label);
        setSelectedStatus(statusToShow);
      }
    } else {
      setSelectedStatus((prevState) => [...prevState, label]);
    }
  };

  const handleChangeTab = (event: React.SyntheticEvent, value: string) => {
    setBarChartDataByPerdas([])
    setBarChartDataByAll([])
    setAnimals([])
    if (value === "perda_parto") setDatePlaceholder(translations["lbl.react.data.cobertura"])
    else setDatePlaceholder(translations["lbl.react.data.cobertura"])
    setSelectedTab(value);
  };

  const handleGetAnimals = useCallback(async (filters: FiltersType) => {
    setLoading(true)
    const proCodigo = searchParams.get('pro_codigo');

    const params = {
      proCodigo: proCodigo,
      dataIni: filters.startDate,
      dataFim: filters.endDate,
      espCodigo: filters.espCodigo,
      racCodigo: filters.racCodigo,
      sexo: filters.sexo,
      lotCodigo: filters.lotCodigo,
      catCodigo: filters.catCodigo,
      statusCria: filters.statusCria
    }

    const token = searchParams.get('token')

    const result:{status: number, data: Reproduction[]} = await getAnimaisPerdaPreParto(params, token)

    const farmsResult = await getPropriedades(proCodigo, token).then((data: any) => data.filter((currFarm: FarmsType) => currFarm.proCodigo === Number(proCodigo))[0].proDescricao);
    setFarmName(farmsResult);

    if (result != null) {
      setAnimals(result.data)
      console.log(result.data)
      console.log(result.data.map(animal => animal.animal.idVisual))

      const allStatusAborto: StatusList = {
        animals: [],
        name: translations["lbl.react.data.aborto"]
      }
      const allStatusNatimorto: StatusList = {
        animals: [],
        name: translations["lbl.react.natirmorto"]
      }
      const allStatusPerdaEmbrionaria: StatusList = {
        animals: [],
        name: translations["lbl.react.perda.embrionaria"]
      }

      result.data.forEach((animal: Reproduction) => {
        if (animal.cobIndStatus! === 3) {
          allStatusAborto.animals.push(animal)
        }
        if (animal.cobIndStatus! === 5) {
          allStatusNatimorto.animals.push(animal)
        }
        if (animal.cobIndStatus! === 6) {
          allStatusPerdaEmbrionaria.animals.push(animal)
        }
      })
      const onlyStatusPerdasLength = allStatusAborto.animals.length + allStatusNatimorto.animals.length + allStatusPerdaEmbrionaria.animals.length;
      const mappedDataByPerdas = [allStatusAborto, allStatusNatimorto, allStatusPerdaEmbrionaria].filter(statusList => statusList.animals.length > 0).map((statusList: StatusList) => (
        {
          "xData": statusList.name,
          "yData": result.data.length > 0 ? parseFloat(((statusList.animals.length / onlyStatusPerdasLength) * 100).toFixed(2)): 0,
          "rawData": statusList.animals,
          "name": translations["lbl.react.animais"],
          "color": "#607d8b"
        }
      ))
      const mappedDataByTotal = [allStatusAborto, allStatusNatimorto, allStatusPerdaEmbrionaria].filter(statusList => statusList.animals.length > 0).map((statusList: StatusList) => (
        {
          "xData": statusList.name,
          "yData": result.data.length > 0 ? parseFloat(((statusList.animals.length / result.data.length) * 100).toFixed(2)) : 0,
          "rawData": statusList.animals,
          "name": translations["lbl.react.animais"],
          "color": "#607d8b"
        }
      ))
      setStatusList([
        {
          name: translations["lbl.react.data.aborto"],
          absValue: allStatusAborto.animals.length,
          percentValueByPerdas: (allStatusAborto.animals.length / onlyStatusPerdasLength * 100).toFixed(2) + "%",
          percentValueByAll: (allStatusAborto.animals.length / result.data.length * 100).toFixed(2) + "%"
        },
        {
          name: translations["lbl.react.natirmorto"],
          absValue: allStatusNatimorto.animals.length,
          percentValueByPerdas: (allStatusNatimorto.animals.length / onlyStatusPerdasLength * 100).toFixed(2) + "%",
          percentValueByAll: (allStatusNatimorto.animals.length / result.data.length * 100).toFixed(2) + "%"
        },
        {
          name: translations["lbl.react.perda.embrionaria"],
          absValue: allStatusPerdaEmbrionaria.animals.length,
          percentValueByPerdas: (allStatusPerdaEmbrionaria.animals.length / onlyStatusPerdasLength * 100).toFixed(2) + "%",
          percentValueByAll: (allStatusPerdaEmbrionaria.animals.length / result.data.length * 100).toFixed(2) + "%"
        },
        {
          name: translations["lbl.react.total"],
          absValue: onlyStatusPerdasLength,
          percentValueByPerdas: (onlyStatusPerdasLength / onlyStatusPerdasLength * 100).toFixed(2) + "%",
          percentValueByAll: (onlyStatusPerdasLength / result.data.length * 100).toFixed(2) + "%"
        }
      ])
      setSelectedStatus(statusParicaoEnum);
      setAllStatus(statusParicaoEnum);
      setFiltersPrintRef({
        'espCodigo': translations["lbl.react.filter.especie"],
        'racCodigo': translations["lbl.react.filter.raca"],
        'catCodigo': translations["lbl.react.filter.categoria"],
        'lotCodigo': translations["lbl.react.filter.lote"],
      });
      setAllPerdasLength(onlyStatusPerdasLength)
      setBarChartDataByPerdas(mappedDataByPerdas);
      setBarChartDataByAll(mappedDataByTotal)

      const generatedCardList = [
        {
          title: translations["lbl.react.card.numero.gestantes"],
          value: result.data.length,
          big: true,
          tooltip: ""
        },
        {
          title: translations["lbl.react.card.perdas.pre.parto"],
          value: allStatusAborto.animals.length + allStatusNatimorto.animals.length + allStatusPerdaEmbrionaria.animals.length,
          big: true,
          tooltip: ""
        },
        {
          title: translations["lbl.react.card.indicador.perdas"],
          value: (((allStatusAborto.animals.length + allStatusNatimorto.animals.length + allStatusPerdaEmbrionaria.animals.length) / result.data.length) * 100).toFixed(2) + "%",
          big: true,
          tooltip: ""
        }
      ];
      
      setCardList(generatedCardList);
    }

    setLoading(false)
    
  }, [searchParams, statusParicaoEnum, translations]);

  const handleSearchButton = (filters: FiltersType) => {
    const mappedFilters = {
      ...filters,
      startDate: filters.startDate ? dayjs(filters.startDate).format("YYYY-MM-DD") : "",
      endDate: filters.endDate ? dayjs(filters.endDate).add(1, 'months').subtract(1, 'days').format("YYYY-MM-DD") : ""
    }
    handleGetAnimals(mappedFilters)
  }

  const handleCloseTable = (name: string) => {}

  useEffect(() => {

    if (selectedTab !== "") {
      handleGetAnimals({
        startDate: '',
        endDate: '',
        espCodigo: '',
        racCodigo: '',
        sexo: '',
        lotCodigo: '',
        catCodigo: '',
        statusCria: ''
      });
    }

  }, [handleGetAnimals, selectedTab]);

  useEffect(() => {

    const initialTab = searchParams.get('indicador') || "perda_parto"
    const languageParam = searchParams.get('language') || 'pt'
    setLanguage(languageParam)
    setSelectedTab(initialTab)
    if (translations) {
      if (initialTab === "perda_parto") setDatePlaceholder(translations["lbl.react.data.cobertura"])
      else setDatePlaceholder(translations["lbl.react.data.cobertura"])
    }

  }, [searchParams, setLanguage, translations]);

  useEffect(() => {
    handleTableData()

  }, [handleTableData, translations]);

  return (
    <Grid container justifyContent="center">
      { translations &&
        <Grid item xs={12}>
          <div className="page-body">
            <span className="page-title">
              { translations["lbl.react.indicadores.perda.pre.parto"] }
            </span>
            <Grid container rowSpacing={2} justifyContent="center">
              <Grid item xs={12}>
                { selectedTab &&
                  <Tabs handleChange={handleChangeTab} value={selectedTab} labels={[{ label: translations["lbl.react.aba.perdas.pre.parto"], name: "perda_parto" }]}/>
                }
              </Grid>
              <Grid item xs={12}>
                <Filter
                  handleSearch={handleSearchButton}
                  datePlaceholder={datePlaceholder}
                  selectedTab={selectedTab}
                  showFilters={showFilters.perda_parto}
                  onlyMonths={true}
                  dateFormat="MM/yyyy"
                />
              </Grid>
              { loading === false ?
                <Grid item xs={12}>
                  {selectedTab === "perda_parto" && (
                    animals.length ?
                      <div>
                        <PageForPrint reference={printRef2} farmName={farmName} chartTitle={translations["lbl.react.resumo.geral"]} onlyMonths={false} usedFilters={filtersPrintRef}>
                          <Grid container className="chart-container" mb={2}>
                            <Grid item xs={12}>
                              <AccordionCustom
                                title={translations["lbl.react.resumo.geral"]}
                                subtitle={null}
                                amountText={""}
                                intervalTotal={0}
                                topButtons={<Printer componentRef={printRef2} setIsPrinting={setIsPrinting} chartTitle={translations["lbl.react.resumo.geral"]} />}
                              >
                                <Grid container item xs={12} pb={2} mb={3} className='card-container'>
                                  {cardList && cardList.map((cardItem: CardItem) => {
                                  return <Card title={cardItem.title} textValue={cardItem.value} colorType={cardItem.big ? "green" : "gray"} big={cardItem.big} tooltipText={cardItem.tooltip && cardItem.tooltip} />;
                                  })}
                                </Grid>
                              </AccordionCustom>
                            </Grid>
                          </Grid>
                        </PageForPrint>
                        <PageForPrint reference={printRef1} farmName={farmName} chartTitle={translations["lbl.react.aba.perdas.pre.parto"]} usedFilters={filtersPrintRef}>
                          <Grid container className="chart-container">
                            <Grid item xs={12}>
                              <AccordionCustom
                                title={!barChartByReproduction ? translations["lbl.react.aba.perdas.pre.parto"] : translations["lbl.react.aba.perdas.pre.parto"]}
                                subtitle={<Grid item xs marginTop={1} marginLeft={1}>
                                  <SwitchCustom
                                    className="two-options-switch"
                                    switchValue={barChartByReproduction || false}
                                    name='barChartByReproduction'
                                    handleSwitch={() => setBarChartByReproduction(!barChartByReproduction)}
                                    leftLabel={<Grid container alignItems={"center"} columnGap={"4px"}><span>{translations["lbl.react.composicao.perdar.pre.parto"]}</span><Tooltip title={translations["lbl.react.composicao.perdar.pre.parto.tooltip"]}><InfoIcon className='info-icon' fontSize='small' style={{stroke:"#ffffff83"}}/></Tooltip></Grid>}
                                    label={<Grid container alignItems={"center"} columnGap={"4px"}><span>{translations["lbl.react.incidencia.perdas.pre.parto"]}</span><Tooltip title={translations["lbl.react.incidencia.perdas.pre.parto.tooltip"]}><InfoIcon className='info-icon' fontSize='small' style={{stroke:"#ffffff83"}}/></Tooltip></Grid>}
                                  />
                                </Grid>}
                                amountText={barChartByReproduction ? translations["lbl.react.numero.femeas.gestantes.intervalo"] : translations["lbl.react.numero.perdas.pre.parto.intervalo"]}
                                intervalTotal={barChartByReproduction ? animals.length : allPerdasLength}
                                topButtons={<Printer componentRef={printRef1} chartTitle={translations["lbl.react.aba.perdas.pre.parto"]} />}
                              >
                                { barChartByReproduction ?
                                  <Grid container item xs={12}>
                                    <Grid container item xs={12} pb={2} mb={3}>
                                      <BarChart
                                        data={barChartDataByAll}
                                        barLabel={translations["lbl.react.animais"]}
                                        sideLabel={translations["lbl.react.taxa.perda.pre.parto.porcentagem"]}
                                        limiteYAxis
                                        yAxisUnit="%"
                                        indexValues={true}
                                        handleSelectBar={handleSelectBars}
                                      />
                                    </Grid>
                                    <Grid container item xs={12} justifyContent={"center"}>
                                      <GenericSummary chartData={{
                                          headerData: {
                                            tooltips: [],
                                            data: [ "Tipo da perda", "Quantidade", "Percentual"]
                                          },
                                          contentData: [ 
                                            [ statusList[0].name, statusList[0].absValue, statusList[0].percentValueByAll],
                                            [ statusList[1].name, statusList[1].absValue, statusList[1].percentValueByAll],
                                            [ statusList[2].name, statusList[2].absValue, statusList[2].percentValueByAll],
                                            [ statusList[3].name, statusList[3].absValue, statusList[3].percentValueByAll],
                                          ],
                                          dataTooltips: []
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                :
                                  <Grid container item xs={12}>
                                    <Grid container item xs={12} pb={2} mb={3}>
                                      <BarChart
                                        data={barChartDataByPerdas}
                                        barLabel={translations["lbl.react.animais"]}
                                        sideLabel={translations["lbl.react.compisicao.perda.pre.parto.porcentagem"]}
                                        limiteYAxis
                                        yAxisUnit="%"
                                        indexValues={true}
                                        handleSelectBar={handleSelectBars}
                                      />
                                    </Grid>
                                    <Grid container item xs={12} justifyContent={"center"}>
                                      <GenericSummary chartData={{
                                          headerData: {
                                            tooltips: [],
                                            data: [ "Tipo da perda", "Total", "Percentual"]
                                          },
                                          contentData: [ 
                                            [ statusList[0].name, statusList[0].absValue, statusList[0].percentValueByPerdas],
                                            [ statusList[1].name, statusList[1].absValue, statusList[1].percentValueByPerdas],
                                            [ statusList[2].name, statusList[2].absValue, statusList[2].percentValueByPerdas]
                                          ],
                                          dataTooltips: []
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                }
                              </AccordionCustom>
                            </Grid>
                            { selectedStatus.length > 0 &&
                              <Box className="hide-to-print" sx={{ width: "100%", backgroundColor: "#efefef", border: "1px solid #e7ebee", borderRadius: "3px", margin: "0 16px 16px 16px"} }>
                                <Grid item container p={2}>
                                  <Grid item xs={12} mb={2}>
                                    <span className="c-b-cinza-icons chart-warning">{translations["lbl.react.para.ocultar.ou.exibir.clique"] + "."}</span>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <span>{translations["lbl.react.tabela.status.prenhez.selecionados"]}</span>
                                  </Grid>
                                  <Grid item container xs={12} mt={2} columnSpacing={2}>
                                    {
                                      allStatus.map((status) => <Badge label={status} handleDelete={handleDelete} key={status} deletable={selectedStatus.length !== 1 || !selectedStatus.includes(status)} addOrDel={selectedStatus.includes(status)} />)
                                    }
                                  </Grid>
                                </Grid>
                              </Box>
                            }
                          </Grid>
                        </PageForPrint>
                        { selectedStatus.length > 0 &&
                          <Table
                            columns={fieldsTables(translations).perdasPreParto}
                            rows={selectedAnimalsByStatus}
                            idColumn='cobCodigo'
                            sortColumn='cobCodigo'
                            tableTitle={translations["lbl.react.dados.para.status.prenhez.selecionados"]}
                            handleCloseTable={handleCloseTable}
                            name="previsao"
                            showColumns={showColumns.perdasPreParto}
                          />
                        }
                      </div>
                    :
                      <div>
                        <EmptyState />
                      </div>
                    )
                  }
                </Grid>
                :
                <Loading />
              }
            </Grid>
          </div>
        </Grid>
      }
    </Grid>
  );
}

export default IndicadoresPerdaPreParto;